module.exports = __webpack_public_path__ + "img/CobravsPTF.1ebbfe99.png";